<script setup lang="ts">
import { computed } from 'vue'
import { docsUrl } from '@/lib/docs'

const props = defineProps<{ path: string }>()
const href = computed(() => docsUrl(props.path))
</script>

<template>
	<a
		data-testid="docs-link"
		:href="href"
		target="_blank"
		rel="noopener noreferrer"
		class="text-xs text-muted-foreground underline underline-offset-4 hover:text-foreground"
	>Docs</a>
</template>
